/**
 * Getting Started - About Component
 * Alpine.js component for the "Tell us about yourself" step
 */

/**
 * About text editor component factory
 * Handles character count, progress bar, and validation
 */
export function gettingStartedAbout(initialText = '') {
    return {
        // State
        text: initialText,
        minLength: 50,
        showForm: false,

        // Computed
        get charCount() {
            return this.text.length;
        },

        get remaining() {
            return Math.max(0, this.minLength - this.charCount);
        },

        get isValid() {
            return this.charCount >= this.minLength;
        },

        get textareaClass() {
            const base = 'w-full min-h-[140px] p-3 sm:p-4 border-2 rounded-xl text-base text-gray-800 transition-colors duration-200 resize-y mb-3 bg-white focus:ring-0 focus:outline-none';
            if (this.charCount === 0) return `${base} border-gray-200 focus:border-blue-500`;
            if (this.isValid) return `${base} border-emerald-400 focus:border-emerald-500`;
            return `${base} border-gray-200 focus:border-blue-500`;
        },

        // Methods
        showFormPanel() {
            this.showForm = true;
            this.$nextTick(() => {
                this.$refs.textarea?.focus();
            });
        },

        handleSubmit() {
            if (!this.isValid) {
                this.$refs.textarea?.focus();
                return false;
            }
            return true;
        }
    };
}
